import { datadogLogs } from '@datadog/browser-logs';
import { FC, useEffect } from 'react';
import { PatternResults } from '../OverviewTab';
import { ResultLines } from '../styles';
import { PatternViewProps } from './types';

const FallbackView: FC<PatternViewProps> = ({ entry, pattern, evidence }) => {
  useEffect(() => {
    datadogLogs.logger.warn('advanced_fraud_trends_fallback_view', {
      check_key: entry.check_key,
      evaluation_id: entry.evaluation_id,
      template: entry.template,
      pattern: pattern.key,
      view: pattern.view
    });
  }, [entry.check_key, entry.evaluation_id, entry.template, pattern.key, pattern.view]);

  return (
    <ResultLines data-testid="advanced-fraud-trends-fallback">
      <PatternResults pattern={pattern} evidence={evidence} />
    </ResultLines>
  );
};

export default FallbackView;
